import { Role } from '@/core/domain/enterprise/Roles/Roles.types';
import { RoleName } from './profile.config';
import Authorities from '@/types/Authority';
import { isAppPortocar } from '@/index';

export interface RoleSubGroup extends RoleGroup {
  id: number;
  roles?: RoleSubGroup[];
}

export interface RoleGroup {
  key: string;
  name: string;
  id?: number;
  roles?: RoleSubGroup[];
  code: string;
}

function getKeys(key: string) {
  return key.split('_');
}

function sortData(data: RoleGroup[]) {
  return data.sort((a, b) => a.name.localeCompare(b.name));
}

export const disableRoleInPorto = (role: { code: string }) => {
  if (!isAppPortocar) return false;

  const codes: string[] = [
    Authorities.MOVIMENTATION_WORKORDER_GENERATE_INVOICE_TO_AUTHORIZED,
  ];
  return codes.includes(role.code);
};

export function threeRoles(roles?: Role[]) {
  return (
    roles?.reduce<RoleGroup[]>((acc, role) => {
      if (role.authorityType) {
        const keys = getKeys(role.authorityType);

        const roleGroupIndex = acc.findIndex((item) => keys[0] === item.key);

        if (roleGroupIndex > -1) {
          let roleGroup = acc[roleGroupIndex];

          const roleSubGroupIndex = roleGroup.roles?.findIndex(
            (item) => item.key === keys[1],
          );

          if (
            roleGroup.roles?.length &&
            typeof roleSubGroupIndex === 'number' &&
            roleSubGroupIndex > -1
          ) {
            const roleSubGroup = roleGroup.roles[roleSubGroupIndex];

            roleGroup.roles[roleSubGroupIndex] = {
              ...roleSubGroup,
              roles: [
                ...(roleSubGroup?.roles || []),
                {
                  id: role.id,
                  key: role.authorityType,
                  name: role.description,
                  code: role.code,
                },
              ].filter((role) => !disableRoleInPorto(role)),
            };
          } else {
            const roleName = RoleName[keys[1]] || RoleName[keys[0]];

            if (roleName) {
              roleGroup = {
                ...roleGroup,
                roles: [
                  ...(roleGroup.roles || []),
                  {
                    code: role.code,
                    key: keys[1],
                    name: RoleName[keys[1]] || RoleName[keys[0]],
                    id: role.id,
                    roles: [
                      {
                        id: role.id,
                        key: role.authorityType,
                        name: role.description,
                        code: role.code,
                      },
                    ].filter((role) => !disableRoleInPorto(role)),
                  },
                ],
              };
            }
          }

          acc[roleGroupIndex] = {
            ...roleGroup,
            roles: [...(roleGroup.roles || [])],
          };

          return sortData(acc);
        }

        if (RoleName[keys[0]]) {
          return sortData([
            ...acc,
            {
              code: role.code,
              key: keys[0],
              name: RoleName[keys[0]],
              roles: [
                {
                  code: role.code,
                  key: keys[1],
                  name: RoleName[keys[1]] || RoleName[keys[0]],
                  id: role.id,
                  roles: [
                    {
                      key: role.authorityType,
                      name: role.description,
                      id: role.id,
                      code: role.code,
                    },
                  ].filter((role) => !disableRoleInPorto(role)),
                },
              ],
            },
          ]);
        }
      }

      return sortData(acc);
    }, []) || []
  );
}
